import { shareColumnsExtend, shareFormColumnsExtend } from '../share';

const entityColumns = {
  id: {
    model_name: 'Walk::Prize',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Walk::Prize',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Walk::Prize',
    column_type: 'datetime',
  },
  title: {
    model_name: 'Walk::Prize',
    column_type: 'string',
  },
  introduction: {
    model_name: 'Walk::Prize',
    column_type: 'text',
  },
  covers: {
    model_name: 'Walk::Prize',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
  covers_with_audio: {
    model_name: 'Walk::Prize',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 5,
    },
  },
  images: {
    model_name: 'Walk::Prize',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
  images_with_audio: {
    model_name: 'Walk::Prize',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 5,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
